import graphql from './graphql';

const query = /* GraphQL */ `
  query Course($id: ID) {
    Course(id: $id) {
      id
      name
      description
      trainingHours
      expirationRule
      dueAmount
      dueUnit
      updatedAt
      thumbnail
      isDraft
      Priority {
        name
        id
      }
      CourseCategory {
        name
        id
      }
      User {
        fullName
        photo
      }
    }
  }
`;

/**
 * Busca un curso por su id.
 *
 * Cuando la petición falla —curso inexistente o borrado, id nulo, sesión
 * vencida— `graphql` no devuelve datos sino `{ error: true, ... }`, que no
 * tiene la clave `Course`. Destructurarlo a ciegas entregaba `undefined` y el
 * llamador reventaba al leer `course.id` sin saber que la petición había
 * fallado. Un curso que no se pudo cargar se reporta como `null`.
 *
 * @param {{id: string}} params
 * @returns {Promise<Object|null>} El curso, o `null` si no se pudo cargar.
 */
const CourseFindById = async ({ id }) => {
  const response = await graphql(query, { id });

  return response?.error ? null : response.Course;
};

export default CourseFindById;
